module.exports = __webpack_public_path__ + "static/media/Dikaiwsi_2.2fd0eef6.jpg";